import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Project} from '../model/project';
import {Questionnaire} from '../model/questionnaire';
import {Terminal} from '../model/terminal';
import {FileToDownload} from '../model/file-to-download';
import {ContextMenuComponent} from '../context-menu/context-menu.component';
import {ImportDuplicateModalComponent} from '../import-duplicate-modal/import-duplicate-modal.component';
import {ImportOption} from '../model/importOptionEnum';
import {ProjectService} from '../project/project.service';
import {ImportRequirement} from '../model/import-requirement';
import {ProjectLevel,ProjectLevelUtil} from '../model/projectLevelEnum';
import {CurrentContext} from '../model/currentContext';
import {SharedRefreshService} from '../service/sharedRefreshService';

@Component({
  selector:'present-by-list',
  template:`
    <div class="table" id="results">
      <div class='theader col-md-12'>
        <div class='table_header'>Name</div>
        <div class='table_header'>Date Modified</div>
        <div class='table_header'>Size</div>
        <div class='table_header'>Kind</div>
      </div>
    </div>
    <div *ngFor="let project of projectList" class="table-row">
      <div class="entry2 col-lg-12" >
        <div class="col-lg-5" style="float:left"><span data-toggle="collapse" [attr.data-target]="'#' + generateLinkId('P'+project.id)"><i style="color:#8e8e8e;font-size: 20px;" (click)="toggle(project)" [ngClass]="project.isSelected ? 'fas fa-caret-down' : 'fas fa-caret-right'" ></i></span><span><i style="color:#81d8fd;font-size:20px;padding-left: 20px;" class="fas fa-folder"></i></span><span class="table_cell fileName">{{project.name}}</span></div>
        <span class="col-lg-4 table_cell">{{project.createdDate.split('T')[0]}}</span>
        <span class="col-lg-1 table_cell"> 10 KB</span>
        <span class="col-lg-2 table_cell">Project</span>
      </div>

      <div *ngFor="let quest of project.questionnaires"  class="table-row" (click)="hideContext()">
        <div class="entry2 col-lg-12"  [ngClass]="quest.isSelected ? 'collapse in' : 'collapse'" id="{{generateLinkId('P'+quest.projectId)}}">
          <div style="float:left" class="col-lg-5 table_cell" ><span data-toggle="collapse" [attr.data-target]="'#' + generateLinkId('Q'+quest.id)"><i style="color:#8e8e8e;font-size: 20px;padding-left: 20px;" (click)="toggleQuestionnaire(quest)" [ngClass]="quest.isSelected ? 'fas fa-caret-down' : 'fas fa-caret-right'" ></i></span><span style="margin-left:30px; "><i style="font-size: 20px; color:#81d8fd;margin-right:20px;" class="fas fa-folder"></i></span><span class="fileName">{{quest.name}}</span></div>
          <span class="col-lg-4 table_cell"></span>
          <span class="col-lg-1 table_cell"></span>
          <span class="col-lg-2 table_cell"></span>
        </div>

        <div class="table-row entry2 col-lg-12" (click)="onQuestionnaireSelected(quest,$event)" (dblclick)="onRightClick($event)" data-node-type="questionnaire" [ngClass]="quest.isSelected ? 'collapse in' : 'collapse'" id="{{generateLinkId('Q'+quest.id)}}"><td><span style="margin-left:93px; "><i style="font-size: 16px; color:#81d8fd;margin-right:20px;" class="fas fa-file-code"></i></span><span class="fileName">{{quest.name}}</span></td></div>
        <div class="table-row" *ngFor="let terminal of quest.terminals">
          <div class="entry2 col-lg-12" (dblclick)="onRightClick($event)" (click)="toggleTerminal(terminal)" data-node-type="terminal" [ngClass]="terminal.isSelected ? 'collapse in' : 'collapse'" id="{{generateLinkId('Q'+terminal.associatedQuestionnaireId)}}">
            <div  style="float:left" class="col-lg-5 table_cell"><span data-toggle="collapse" [attr.data-target]="'#' + generateLinkId('T'+terminal.name)"><i style="color:#8e8e8e;font-size: 20px;padding-left: 55px;"  [ngClass]="terminal.isSelected ? 'fas fa-caret-down' : 'fas fa-caret-right'" ></i></span><span style="margin-left:30px; "><i style="font-size: 20px; color:#81d8fd;margin-right:20px;" class="fas fa-folder"></i></span><span class="fileName">{{terminal.name}}</span></div>
            <span class="col-lg-4 table_cell"></span>
            <span class="col-lg-1 table_cell"></span>
            <span class="col-lg-2 table_cell"></span>
          </div>

          <div class="table-row-terminal" *ngFor="let file of terminal.filesToDownload">
            <div class="entry2 col-lg-12" (click)="onFileSelected(file)" (dblclick)="onRightClick($event)" data-node-type="file"  [ngClass]="terminal.isSelected ? 'collapse in' : 'collapse'" id="{{generateLinkId('T'+file.associatedTerminalName)}}">
              <div style="float:left" class="col-lg-7 table_cell" ><span style="margin-left:115px; "><i style="font-size: 17px; color:#81d8fd;margin-right:15px;" class="fas fa-file"></i></span><span class="fileName">{{file.src}}</span></div>
              <span class="col-lg-3 table_cell"></span>
              <span class="col-lg-1 table_cell"></span>
              <span class="col-lg-1 table_cell"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showContext == true">
      <context-menu [top]="x-550" [left]="y" (import)="onImport()"></context-menu>
    </ng-container>
    <generic-info-modal  [hide]="_hide" [statusCode]="_statusCode" [title]="_modalTitle" [text]="_modalText" (OkClick)="onOk()"></generic-info-modal>
    <import-duplicate-modal (importOptions)="onExecuteImport($event)"></import-duplicate-modal>
  `,
  styles:[`
    span{font-family: Helvetica;color:#3c3c4b;}
    .theader {
      display: table-cell;
      border-bottom: #ccc 1px solid;
      border-top: #ccc 1px solid;
      background: #bdbdbd;
      color: #e5e5e5;
      padding-top: 10px;
      padding-bottom: 10px;
      font-weight: 700;
    }

    .table {
      display: table;
      text-align: center;
      width: 100%;
      margin: 10px auto 0;
      border-collapse: separate;
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
    }

    .theader {
      display: table-row;
    }

    .table_header {
      display: table-cell;
      border-bottom: #ccc 1px solid;
      border-top: #ccc 1px solid;
      background-image: linear-gradient(to right, #e9eef1 0%, #f0f0f0 100%);
      color: #0f0f0f;
      border-right: #e6e6e6 2px solid;
      padding-top: 10px;
      padding-bottom: 10px;
      font-weight: 700;
    }

    .table_header:first-child {
      border-left: #ccc 1px solid;
      border-top-left-radius: 5px;
    }

    .table_header:last-child {
      border-right: #ccc 1px solid;
      border-top-right-radius: 5px;
    }

    .table_small {
      display: table-cell;
    }
    .table_cell{color:#909090;padding-left:15px;}

    .table-row :nth-last-child(odd) {
    }

    .table-row:nth-child(even) {
      background: #ffffff;
    }

    .table-row-terminal :nth-last-child(even) {
    }

    .table-row-terminal:nth-child(odd) {
      background: #ffffff;
    }

    .fileName{color:#0f0f0f;font-weight: bold;font-size: small;}

    .entry2:active{
      background-image: -webkit-linear-gradient(top, #648bf5, #2866f2);
      background-image: linear-gradient(to bottom, #648bf5 0%, #2866f2 100%);
      border-top: 1px solid #5a82eb;
      border-bottom: 1px solid #1758e7;}

    .entry2:active > div .fileName{color: #ffffff;}
  `]
})

export class PresentByListComponent implements OnInit {
  @Input('projectList') projectList:Project[];
  @Input() targetName:string;
  @Input() context:CurrentContext;

  private _selectedProject = new Project();
  private _selectedQuestionnaire = new Questionnaire();
  private _selectedTerminal = new Terminal();
  private exploded = false;
  private exploreQuestionnaire =  false;
  private exploreTerminal =  false;
  private _selectedFile:FileToDownload;

  private questionnaireArray = [];

  private showContext= false;

  private x:number;
  private y:number;

  private _modalTitle;
  private _modalText:string;
  private _hide = true;
  private _statusCode = 200;


  @ViewChild(ContextMenuComponent) private contextMenu:ContextMenuComponent;
  @ViewChild(ImportDuplicateModalComponent) private importModal:ImportDuplicateModalComponent;

  constructor(private _projectService:ProjectService,private _refreshService:SharedRefreshService) {

  }

  ngOnInit(): void {
    // this.importModal.setProjectLevel(ProjectLevel.questionnaireLevel);
  }



  private generateLinkId(name:string) {
    if(name.includes(' ')) {
      const tmp = name.indexOf(' ');
      const newName = name.substring(0,tmp)+name.substring(tmp+1,name.length);

      return newName+'FileChooser';
    }

    return name+'FileChooser';
  }

  private toggleTerminal(terminal:Terminal) {
    terminal.isSelected = !terminal.isSelected;
    this.exploreTerminal = true;
    this._selectedTerminal = terminal;
  }

  private toggleQuestionnaire(quest:Questionnaire) {
    this._selectedFile = null;
    this.questionnaireArray = [];
    this.questionnaireArray.push(quest);
    quest.isSelected = !quest.isSelected;
    this.exploreQuestionnaire = true;
    this._selectedQuestionnaire = quest;
  }

  private toggle(project: Project) {
    this._selectedFile = null;
    this.exploded = !this.exploded;
    project.isSelected = !project.isSelected;
    this._selectedProject =  project;
  }

  onQuestionnaireSelected(_selectedQuestionnaire: Questionnaire,src:any) {
    src.target.backgroundColor = 'antiquewhite';
    console.log(_selectedQuestionnaire.name);
  }

  onFileSelected(file: FileToDownload) {
    console.log(file.src);
    this._selectedFile = file;
  }

  onRightClick(event: MouseEvent) {
    // this.contextMenu.setCoordinates();
    // this.contextMenu.toggle();
    // @ts-ignore
    if(ProjectLevelUtil.getLevel(event.currentTarget.dataset.nodeType) !== (ProjectLevelUtil.getLevel(this.targetName)+1)) {
      // modal alert
      this._modalTitle = 'JuJu Explorer';
      // @ts-ignore
      switch (event.currentTarget.dataset.nodeType) {
        case 'questionnaire' : if(this.targetName!=='project') {this._modalText = 'Questionnaire can only be imported from project level.';}break;
        case 'terminal' : if(this.targetName!=='questionnaire') {this._modalText = 'Terminals can only be imported from Questionnaire level.';}break;
        case 'file' : if(this.targetName!=='terminal') {this._modalText = 'Specific files can only be imported from Terminal level.';}break;
      }
      this._statusCode=250;
      this._hide = false;
      console.log('Only Questionnaire can be imported at project level' + this._hide);
      return;
    }
    this.showContext = true;
    this.x = event.pageX;
    this.y = event.pageY;
  }

  hideContext() {
    this.showContext  = false;
  }

  onImport() {
    console.log(this.targetName);
    this.showContext = false;
    if(this.targetName === 'project') { // we are at a project level. The project exists
      this.importModal.toggle();
      this.importModal.setProjectLevel(ProjectLevel.Questionnaire);
      // modal with options
      // console.log(this._selectedProject.id+'/'+this._selectedQuestionnaire.id+'/'+this._selectedTerminal.id+'/'+this._selectedFile.src);
    }
    if(this.targetName === 'questionnaire') { // we are at questionnaire level. The questionnaire exists already
      this.importModal.toggle();
      this.importModal.setProjectLevel(ProjectLevel.Terminal);
      // modal with options
      // console.log(this._selectedProject.id+'/'+this._selectedQuestionnaire.id+'/'+this._selectedTerminal.id+'/'+this._selectedFile.src);
    }
    if(this.targetName === 'terminal') { // We are within a terminal
      this.importModal.toggle();
      this.importModal.setProjectLevel(ProjectLevel.File);
      // modal with options
      // console.log(this._selectedProject.id+'/'+this._selectedQuestionnaire.id+'/'+this._selectedTerminal.id+'/'+this._selectedFile.src);
    }


  }

  onOk() {
    if(this._statusCode===250) {
      this._hide = true;
      return;
    }
    this._hide = true;
    // document.location.reload(true);
    this._refreshService.refresh(true);
  }

  onExecuteImport(importOpt:ImportOption) {
    const importSpec = new ImportRequirement();

    importSpec.pId = this._selectedProject.id;
    importSpec.qId = this._selectedQuestionnaire.id;
    if(this.targetName === 'questionnaire' || this.targetName === 'terminal') {
      importSpec.tId = this._selectedTerminal.id;
      importSpec.terminalType = this._selectedTerminal.type === 'Android'?'2':'1';
    }
    importSpec.importMode = importOpt;

    const newQuest = new Questionnaire();
    newQuest.projectId = Number(this.context.project.id);

    switch(importOpt) {
      case ImportOption.Full: console.log('Import Questionnaire or Terminal completely with all its children');
        if(this.targetName === 'project') {
          this._projectService.createQuestionnaire(newQuest,importSpec).subscribe(data => {

            if(data === 100) {
              this._statusCode = 200;
              this._modalText = 'Questionnaire was imported successfully.';
              this._modalTitle = 'Terminal';
              this._hide = false;
            } else if(102) {
              this._statusCode = data;
              this._modalText = 'An error has occurred while importing questionnaire.';
              this._modalTitle = 'Terminal';
              this._hide = false;
            }
            },
            error => {
            console.log('Error create questionnaire');
              this._statusCode = 301;
              this._modalText = 'An error has occurred while creating questionnaire.';
              this._modalTitle = 'Questionnaire';
              this._hide = false;
          });
        } else if(this.targetName === 'questionnaire') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          this._projectService.createTerminal(term,this.context.qId,importSpec).subscribe(data => {
              const rep = data as  Response;
              if(rep==null) {
                console.log('Error while creating terminal');
                this._statusCode = 406;
                this._modalText = 'An error has occurred while importing terminal.';
                this._modalTitle = 'Terminal';
                this._hide = false;
              } else {
                this._statusCode = 200;
                this._modalText = 'Terminal was successfully imported.';
                this._modalTitle = 'Terminal';
                this._hide = false;
              }
            },
            error => {
              console.log('Error updating terminal');

              this._statusCode = 301;
              this._modalText = 'An error has occurred while importing terminal.';
              this._modalTitle = 'Terminal';
              this._hide = false;
            });
        } else if (this.targetName === 'terminal') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          term.id = this.context.tId;
          this._projectService.updateTerminalNode(term,this.context.project.id,this.context.qId,importSpec.terminalType,importSpec).subscribe(data => {
            if(data === 100) {
              this._statusCode = 200;
              this._modalText = 'Terminal has been successfully imported.';
              this._modalTitle = 'Terminal';
              this._hide = false;
            } else if (102) {
              this._statusCode = data;
              this._modalText = 'An error has occurred while importing terminal.';
              this._modalTitle = 'Terminal';
              this._hide = false;
            }
            },
            error => {
              console.log('Error importing terminal');

              this._statusCode = 301;
              this._modalText = 'An error has occurred while importing terminal.';
              this._modalTitle = 'Terminal';
              this._hide = false;
            });
        }break;
      case ImportOption.Only: console.log('Import Questionnaire only, Terminal only or just a file or folder from the terminal directory');

        if(this.targetName === 'project') {
          this._projectService.createQuestionnaire(newQuest,importSpec).subscribe(data => {
                if(data === 100) {
                  this._statusCode = 200;
                  this._modalText = 'Questionnaire has been successfully imported..';
                  this._modalTitle = 'Questionnaire';
                  this._hide = false;
                } else if (102) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing questionnaire.';
                  this._modalTitle = 'Questionnaire';
                  this._hide = false;
                }
            },
            error => { console.log('Error create client');
              this._statusCode = 301;
              this._modalText = 'An error has occurred importing questionnaire.';
              this._modalTitle = 'Terminal';
              this._hide = false;
          });
        } else if(this.targetName === 'questionnaire') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          this._projectService.createTerminal(term,this.context.qId,importSpec).subscribe(data => {

                const rep = data as Response;
                if(rep!=null) {
                  this._statusCode = 200;
                  this._modalText = 'Terminal has been successfully imported.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (rep.status === 406) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing terminal or single resource.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
            },
            error => {
                console.log('Error create client');
                this._statusCode = 301;
                this._modalText = 'An error has occurred importing questionnaire.';
                this._modalTitle = 'Terminal';
                this._hide = false;
            });
        } else if (this.targetName === 'terminal') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          term.id = this.context.tId;
          importSpec.fileToDownload = this._selectedFile;
          this._projectService.updateTerminalNode(term,this.context.project.id,this.context.qId,importSpec.terminalType,importSpec).subscribe(data => {
                if(data === 100) {
                  this._statusCode = 200;
                  this._modalText = 'Terminal has been successfully updated.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (102) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while updating terminal.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
            },
            error => {
              console.log('Error create client');
              this._statusCode = 301;
              this._modalText = 'An error has occurred importing questionnaire.';
              this._modalTitle = 'Terminal';
              this._hide = false;
            });
        }
        break;
      case ImportOption.TerminalAndAssets: console.log('Import Terminal with assets');
        if(this.targetName === 'project') {
          this._projectService.createQuestionnaire(newQuest,importSpec).subscribe(data => {
                if(data === 100) {
                  this._statusCode = 200;
                  this._modalText = 'Questionnaire has been successfully updated.';
                  this._modalTitle = 'Questionnaire';
                  this._hide = false;
                } else if (102) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing questionnaire.';
                  this._modalTitle = 'Questionnaire';
                  this._hide = false;
                }
            },
            error => {
              console.log('Error create client');
              this._statusCode = 301;
              this._modalText = 'An error has occurred importing questionnaire.';
              this._modalTitle = 'Terminal';
              this._hide = false;
            });
        } else if(this.targetName === 'questionnaire') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          this._projectService.createTerminal(term,this.context.qId,importSpec).subscribe(data => {

                const rep  = data as Response;
                if(rep != null) {
                  this._statusCode = 200;
                  this._modalText = 'Terminal has been successfully imported.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (rep.status == null) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing terminal.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
            },
            error => {
              console.log('Error create client');
              this._statusCode = 301;
              this._modalText = 'An error has occurred importing questionnaire.';
              this._modalTitle = 'Terminal';
              this._hide = false;
            });
        }
        break;
      case ImportOption.TerminalAndPostSynchro: console.log('Import Terminal with Post Synchro');
        if(this.targetName === 'project') {
          this._projectService.createQuestionnaire(newQuest,importSpec).subscribe(data => {
                if(data === 100) {
                  this._statusCode = 200;
                  this._modalText = 'Questionnaire has been successfully imported.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (102) {
                  this._statusCode = data;
                  this._modalText = 'An error has occurred while importing terminal.';
                  this._modalTitle = 'Questionnaire';
                  this._hide = false;
                }
            },
            error =>  {
              console.log('Error importing questionnaire');
              this._statusCode = 301;
              this._modalText = 'An error has occurred importing questionnaire.';
              this._modalTitle = 'Questionnaire';
              this._hide = false;
            });
        } else if(this.targetName === 'questionnaire') {
          const term = new Terminal();
          term.associatedQuestionnaireId = this.context.qId;
          this._projectService.createTerminal(term,this.context.qId,importSpec).subscribe(data => {
                const rep = data as Response;
                if(rep != null) {
                  this._statusCode = 200;
                  this._modalText = 'Terminal has been successfully imported.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                } else if (rep == null) {
                  this._statusCode = 301;
                  this._modalText = 'An error has occurred while importing terminal. Verify that you have defined a questionnaire.';
                  this._modalTitle = 'Terminal';
                  this._hide = false;
                }
            },
            error => {
              console.log('Error importing terminal');
              this._statusCode = 301;
              this._modalText = 'An error has occurred importing questionnaire.';
              this._modalTitle = 'Questionnaire';
              this._hide = false;
            });
        }
        break;
    }
  }
}
